<template>
  <div>
  </div>
</template>

<script>
import Service from '@/service/index.js';
export default {
  data () {
    return {
      id: ''
    };
  },
  created () {
    this.id = this.$route.params.id;
    if (this.id) {
      Service.getSignUrl(this.id).then(res => {
        if (res && res.code === '0') {
          window.location.href = res.data;
        } else if (res && res.reason) {
          this.toast({
            message: res.reason,
            duration: 2
          });
        } else {
          this.toast({
            message: '系统异常，请稍后重试',
            duration: 2
          });
        }
      }, () => {
        this.toast({
          message: '系统异常，请稍后重试',
          duration: 2
        });
      });
    }
  }
};
</script>

<style>

</style>
